module.exports = __webpack_public_path__ + "img/0-sm.9216e38c.jpg";